import React from "react";

type SecondaryButtonProps = {
  children: React.ReactNode;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  className?: string;
  id?: string;
};

const SecondaryButton: React.FC<SecondaryButtonProps> = React.memo(
  ({
    children,
    onClick,
    type = "button",
    disabled = false,
    className = "",
    id,
  }) => {
    return (
      <button
        id={id}
        type={type}
        onClick={onClick}
        disabled={disabled}
        className={`
        h-9 px-4 text-sm font-medium
        border border-gray-200
        text-gray-700
        hover:bg-gray-50
        transition-colors
        disabled:opacity-60 disabled:cursor-not-allowed
        rounded-lg
        ${className}
      `}
      >
        {children}
      </button>
    );
  },
);

export default SecondaryButton;
